/* tslint:disable */
/* eslint-disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type PdpRespSidebarButtons_displayInfo = {
    readonly ctas: {
        readonly showPurchase: boolean | null;
        readonly showMakeOffer: boolean | null;
        readonly showRequestPrice: boolean | null;
        readonly showFollowCategory: boolean | null;
        readonly showAcceptOffer: boolean | null;
    } | null;
    readonly " $refType": "PdpRespSidebarButtons_displayInfo";
};
export type PdpRespSidebarButtons_displayInfo$data = PdpRespSidebarButtons_displayInfo;
export type PdpRespSidebarButtons_displayInfo$key = {
    readonly " $data"?: PdpRespSidebarButtons_displayInfo$data;
    readonly " $fragmentRefs": FragmentRefs<"PdpRespSidebarButtons_displayInfo">;
};



const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "PdpRespSidebarButtons_displayInfo",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "CTADisplay",
      "kind": "LinkedField",
      "name": "ctas",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "showPurchase",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "showMakeOffer",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "showRequestPrice",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "showFollowCategory",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "showAcceptOffer",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "ItemDisplayInfo",
  "abstractKey": null
};
(node as any).hash = 'fa6ec6a36939fed0098a9ac67318db85';
export default node;
